// filepath: apps/web/src/features/cabinet/chrome/useTaskCount.ts
//
// FR-UI-CABINET-2 AC-15 — sidebar badge count for tasks due within
// 24 hours.
//
// Reuses the existing `useTasks({view:'mine'})` hook (FR-HT). Tasks
// that are unclaimed or claimed are filtered by `due_at <= now +
// 24h`. The wire format stores due_at as an ISO-8601 string (see
// apps/web/src/features/tasks/types.ts); we parse defensively.
//
// Cache key is shared with the task inbox, so no duplicate fetch.

import { useTasks } from "@/features/tasks/useTasks";

const DAY_MS = 24 * 60 * 60 * 1000;

export function useTaskCount(): number {
  const { tasks } = useTasks({ view: "mine" });
  if (!Array.isArray(tasks)) return 0;
  const horizon = Date.now() + DAY_MS;
  let count = 0;
  for (const t of tasks) {
    const due = parseDueAt(t.due_at);
    if (due === null) continue;
    if (due <= horizon) count += 1;
  }
  return count;
}

function parseDueAt(raw: unknown): number | null {
  if (typeof raw !== "string" || raw.length === 0) return null;
  const ms = Date.parse(raw);
  if (!Number.isFinite(ms)) return null;
  return ms;
}
